import KenSelect from '../../../../GlobalComponents/KenSelect';
import { Box, Button, Divider, InputAdornment, Theme, Grid, Typography, Select, MenuItem, SelectChangeEvent, TextField, IconButton } from '@mui/material';
import KenInput from '../../../../GlobalComponents/KenInput';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MicIcon from '@mui/icons-material/Mic';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { SearchBarProps, searchBarData } from '../../../../interfaces/Common';
import { makeStyles } from '@mui/styles';
import { useStyles as JobStyles } from '../../styles';
import { useEffect, useState } from 'react';
import KenColors from '../../../../Helpers/Themes/kenColors';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useLocation } from 'react-router-dom';
import FilterListIcon from '@mui/icons-material/FilterList';

const useStyles = makeStyles((theme: Theme) => ({
  searchContainer: {
    display: 'flex',
    gap: '10px',
    border: '1px solid #B2B3B7',
    alignItems: 'center',
    borderRadius: '9px',
  },
}));

const SearchBar: React.FunctionComponent<SearchBarProps> = ({ anchorEl1, handleFilter, dropDownData, handleDropDownChange, handleSearchChange, searchBarData }) => {
  const classes = useStyles();
  const jobClasses = JobStyles();
  const [data, setData] = useState<searchBarData>({ dropDown: '', input: '' });
  const [isListening, setIsListening] = useState(false);
  const { pathname } = useLocation();
  const pathSegments: string[] = pathname.split('/').filter((items: string) => items && items !== '');
  const fullPath = pathSegments.join('/');
  useEffect(() => {
    if (searchBarData) {
      setData({ ...searchBarData });
    }
  }, [searchBarData]);

  const handleMicClick = () => {
    if (!('webkitSpeechRecognition' in window)) {
      alert('Speech Recognition is not supported in this browser.');
      return;
    }

    const recognition = new (window as any).webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => {
      setIsListening(true);
      console.log('Voice recognition started');
    };

    recognition.onresult = (event: any) => {
      const transcript = event.results[0][0].transcript;
      console.log('Transcript:', transcript);
      handleSearchChange(transcript); // Update the search input with the recognized text
    };

    recognition.onerror = (event: any) => {
      console.error('Speech recognition error:', event.error);
      alert('Error occurred during speech recognition. Please try again.');
    };

    recognition.onend = () => {
      setIsListening(false);
      console.log('Voice recognition ended');
    };

    recognition.start();
  };

  return (
    <Box padding={'20px'} className="filter-cells-container scrollbar-hide">
      <Grid container spacing={2}>
        <Grid item>
          <Box
            sx={{
              height: '36px',
              width: '50%',
              '@media (min-width: 1280px) and (max-width: 1300px)': {
                height: '30px',
              },
            }}
            display={'flex'}
            justifyContent={'start'}
          >
            {/* <Box sx={{ display: 'flex', alignItems: 'center', border: '1px solid #B2B3B7', borderRadius: '6px 0px 0px 6px' }}>
              <InputAdornment position="start">
                <LocationOnOutlinedIcon
                  sx={{
                    fontSize: '18px',
                    marginLeft: '5px',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '15px',
                    },
                  }}
                />
              </InputAdornment>
              {dropDownData && handleDropDownChange && (
                <Select
                  labelId="custom-select-label"
                  value={data?.dropDown || ''}
                  onChange={(event: SelectChangeEvent<string>) => {
                    const value = event.target.value;
                    console.log('Selected value:', value);

                    if (value !== '') {
                      handleDropDownChange(value);
                    }
                  }}
                  sx={{
                    height: '36px',
                    fontSize: '12px',
                    borderRadius: '6px 0px 0px 6px',
                    width: '100%',
                    border: 'none',
                    outline: 'none',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '&:hover': {
                      border: 'none',
                    },
                    '&.Mui-focused': {
                      border: 'none',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      height: '30px',
                      fontSize: '10px',
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        '& .MuiMenuItem-root': {
                          fontSize: '12px',
                        },
                      },
                    },
                  }}
                >
                  {dropDownData.map((location: any) => {
                    return <MenuItem value={location}>{location}</MenuItem>;
                  })}
                </Select>
              )}
            </Box> */}
            <TextField
              placeholder="Search by Company "
              variant="outlined"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target) {
                  console.log('e.target', e.target, e.target.value);
                  handleSearchChange(e.target.value);
                }
              }}
              value={data?.input || ''}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={handleMicClick}>
                      <MicIcon style={{ fontSize: '18px', color: isListening ? 'red' : 'inherit' }} />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: {
                  height: '36px',
                  minWidth: '260px',
                  borderRadius: '8px',
                },
              }}
              sx={{
                width: { xs: '100%', sm: '260px' },
                maxWidth: '100%',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '',
                  height: '36px',
                  fontSize: '12px',
                },
                '& .MuiInputBase-input::placeholder': {
                  fontSize: '12px',
                },
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '',
                    height: '30px',
                    fontSize: '10px',
                  },
                },
              }}
            />
          </Box>
        </Grid>
        <Grid item>
          {fullPath === 'jobs' ? null : (
            <Button
              size="medium"
              variant="contained"
              color="info"
              endIcon={<FilterListIcon style={{ fontSize: '24px' }} />}
              // onClick={handleFilterOpen}
              onClick={(event) => {
                handleFilter();
                anchorEl1(event.currentTarget);
              }}
            >
              <Typography sx={{ fontWeight: 500 }}>Filters</Typography>
            </Button>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default SearchBar;
